import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";

function IndustryTypeStore({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({
    industry: false,
    store_type: false,
  });

  // Industry options
  const INDUSTRY_OPTIONS = [
    "Service",
    "Transportation",
    "Retail",
    "Food",
    "Entertainment",
    "School",
    "Petrol",
    "Communication",
    "Supermarket",
    "Pharmacy",
    "Travel",
    "Hospital",
    "Utilities",
    "Govternment",
    "QRS",
    "Hospitality"
  ];

  // Type of Store options
  const TYPE_OF_STORE_OPTIONS = [
    "Glass",
    "Kiosk"
  ];

  


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user makes a selection
    if (isError[name]) {
      setIsError(prev => ({
        ...prev,
        [name]: false
      }));
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!primaryDetails.industry) {
      errors.industry = true;
      toast.error("Please select an industry", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    if (!primaryDetails.store_type) {
      errors.store_type = true;
      toast.error("Please select a type of store", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
    }

    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = () => {
    return !!primaryDetails.industry &&
      !!primaryDetails.store_type;
  };
  const handleNext = () => {
    if (validateForm()) {
      navigation.go("can-engage");
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
      

          {/* Main Form */}
          <Col md={10}>
      
              <div className="form-main-header">
                <h4 className="form-title">INDUSTRY & TYPE OF STORE</h4>
                <p className="form-desc">Please select your business details</p>
              </div>
              <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-5" controlId="industry">
                    <Form.Label className="form-label">
                      Industry <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Select
                      name="industry"
                      value={primaryDetails.industry || ""}
                      onChange={handleInputChange}
                      className={`form-input${
                        isError.industry ? " form-input-error" : ""
                      }`}
                    >
                      <option value="">Select Industry</option>
                      {INDUSTRY_OPTIONS.map((industry, index) => (
                        <option key={`industry-${index}`} value={industry}>
                          {industry}
                        </option>
                      ))}
                    </Form.Select>
                    {isError.industry && (
                      <div className="form-error">
                        Please select an industry
                      </div>
                    )}
                  </Form.Group>

                  {/* Type of Store Selection */}
                  <Form.Group className="mb-5" controlId="store_type">
                    <Form.Label className="form-label">
                      Type/Glass of Store <span className="form-required">*</span>
                    </Form.Label>
                    <div>
                      <p className="form-note-text">
                        <em>Glass are stores that have glass and can be opened/closed while Kiosks are stores that are open-fronted or cubicle style.</em>
                      </p>
                    </div>
                    <div className="form-radio-group">
                      {TYPE_OF_STORE_OPTIONS.map((type, index) => (
                        <div
                          key={`type-${index}-${type}`}
                          className={`form-radio-item${primaryDetails.store_type === type ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            {/* <div className="form-radio-index">
                              {String(index + 1).padStart(2, '0')}
                            </div> */}
                            <Form.Check
                              type="radio"
                              id={`type-${index}`}
                              name="store_type"
                              value={type}
                              label={type}
                              checked={primaryDetails.store_type === type}
                              onChange={handleInputChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {isError.store_type && (
                      <div className="form-error">
                        Please select a type of store
                      </div>
                    )}
                  </Form.Group>
                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                      disabled={!isFormValid()}
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default IndustryTypeStore;
